export const TOKENS = {
  "bg": "var(--color-bg)",
  "bg-surface": "var(--color-bg-surface)",
  "bg-brand": "var(--color-bg-brand)",
  "bg-brand-alt": "var(--color-bg-brand-alt)",
  "bg-warning": "var(--color-bg-warning)",
  "bg-modal-backdrop": "var(--color-bg-modal-backdrop)",
  "text": "var(--color-text)",
  "text-secondary": "var(--color-text-secondary)",
  "text-tertiary": "var(--color-text-tertiary)",
  "text-success": "var(--color-text-success)",
  "text-link": "var(--color-text-link)",
  "text-on-brand": "var(--color-text-on-brand)",
  "text-on-brand-alt": "var(--color-text-on-brand-alt)",
  "text-on-warning": "var(--color-text-on-warning)",
  "border": "var(--color-border)",
  "border-on-brand-alt": "var(--color-border-on-brand-alt)",
  "border-selected": "var(--color-border-selected)",
}